import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerlessProvider } from './serverless';
import { SystemDashboardTimetablesApiRequest } from './models/system-dashboard-timetables-api-request';
import { SystemDashboardTimetablesApiResponse } from './models/system-dashboard-timetables-api-response';
import { SystemDashboardTimeTable } from "./models/system-dashboard-time-table";
import { GenericItem } from './models/generic-item';
import { TimeUtil } from '../../utilities/time-util';

/**
 * [システム][ダッシュボード]配車予約一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardTimetablesServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardTimeTables';

  /** 要変換プロパティ */
  private readonly CONVERSION = {
    date: [
      'requestFixedDt',
      'pickUpPlanDt',
      'pickUpLimitDt',
      'dropOffPlanDt',
      'dropOffLimitDt',
      'vehicleArrivalPlanDt',
      'vehicleArrivalDt',
      'vehicleDeparturePlanDt',
      'vehicleDepartureLimitDt'
    ]
  };

  constructor(public serverless: ServerlessProvider) { }

  /**
   * 配車予約一覧を取得する.
   *
   * @param userIds ユーザーIDの一覧
   * @param vehicleIds 車両IDの一覧
   * @param startDt 検索範囲開始日 (yyyy/MM/dd HH:mm:ss)
   * @param endDt 検索範囲終了日 (yyyy/MM/dd HH:mm:ss)
   * @param getCountNumber 取得要素数
   * @param offsetNumber オフセット番号
   * @returns 配車予約一覧
   */
  public get(userIds: number[], vehicleIds: number[], startDt: string, endDt: string, getCountNumber: number, offsetNumber: number): Observable<SystemDashboardTimeTable[]> {
    const requestBody: SystemDashboardTimetablesApiRequest = {
      userIds: userIds,
      vehicleIds: vehicleIds,
      startDt: startDt,
      endDt: endDt,
      getCountNumber: getCountNumber,
      offsetNumber: offsetNumber
    };

    return this.serverless.postApi<SystemDashboardTimetablesApiRequest, GenericItem<SystemDashboardTimetablesApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   *
   * @param responseBody レスポンスボディ
   * @returns 配車予約一覧
   */
  private toModel(responseBody: GenericItem<SystemDashboardTimetablesApiResponse>): SystemDashboardTimeTable[] {
    return responseBody.item.timeTables.map((timetableResponse) => {
      const timetable = {} as SystemDashboardTimeTable;
      for (const key in timetableResponse) {
        if (this.CONVERSION.date.indexOf(key) >= 0) {
          timetable[key] = TimeUtil.toDate(timetableResponse[key]);
          continue;
        }

        timetable[key] = timetableResponse[key];
      }

      return timetable;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-timetables-service.ts